import React from 'react';
import { NavLink } from "react-router-dom"
const Uganda_p6_subjects = () => {
  return (
    <div className="fixed p-4 right-0 left-0 content-center gap-4 w-full h-7 overflow-x-scroll whitespace-nowrap scroll-smooth bg-blue-300  flex scrollbar-hide items-center  top-30 z-9999">
      <NavLink to="/international/uganda/uganda_p6/uganda_p6math" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Mathematics</NavLink>
      <NavLink to="/international/uganda/uganda_p6/uganda_p6eng" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >English</NavLink>
      <NavLink to="/international/uganda/uganda_p6/uganda_p6scie" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Science</NavLink>
      <NavLink to="/international/uganda/uganda_p6/uganda_p6soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Social Studies</NavLink>
        
    </div>

  );
}

export default Uganda_p6_subjects;